import { ButtonC } from 'Common/Buttons';
import React, { useEffect, useState } from 'react';
import InputC from 'Common/Inputs/index.tsx';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import Axios from 'functions/Axios';
import {
  Addfolder,
  DELETE_MULTIPLE_ASSET,
  Editfolder,
  GET_FOLDER_COLORS,
  GET_INSIDE_FOLDER_DATA,
  ROUTED_INNNER_FOLDER_DATA,
  UPDATE_FOLDER_COLOR,
  getSingleFolder,
} from '../DAM_API/urls';
import close from '../../../assets/V2-images/close.svg';
import deleteicon from '../../../assets/V2-images/deleteicon.png';
import renameicon from '../../../assets/V2-images/renameicon.png';
import { Viewbutton } from 'Common/Viewbutton';
import Tabledata from '../Assets/tabledata';
import Uploadfile from '../Uploadfile';
import { Griddata } from '../Assets/griddata';
import SpinnerLoader from './../../SpinnerLoader';
import Nodatacomponent from 'components/Nodatacomponent';
import { toast } from 'react-toastify';
import { Deletemodel } from 'Common/Deletemodel';
import { Assitdata, selectRangeByUUID } from '../Assets/assitdata';
import shareicon from '../../../assets/V2-images/shareicon.png';
import { useDispatch } from 'react-redux';
import {
  SelectedAssetData,
  setInnerFolderDetails,
  setInsideFolderFolderData,
  setInsideFolderId,
  setOpenPopup,
  SetSelctedFoldersData,
} from 'actions/damActions';
import { DAM_SVG } from '../DamAssets';
import { over } from 'stompjs';
import { useSelector } from 'react-redux';
import { DAM_SOCKET_URL } from 'Constant';
import CommonSidePortal from 'Common/SidePortal/SidePortal';
import download from '../../../assets/V2-images/download.png';
import ShareAssetSection from '../Components/Featured/ShareAsset';
import MoveToAssetDesign from '../Components/Featured/MoveToAssetDesign';
import CommonThreeDotSvg from '../Components/CommonThreeDotSvg';
import FolderGridSecondVersion from '../Components/FolderGridSecondVersion';
import WordWrapEllipse from '../WordWrapEllipse';
import SelectionActions from '../Components/Featured/selectionActions';
import { useDropzone } from 'react-dropzone';
import { uploadFiless } from '../Assets';
import { useContainerRef } from 'context/ContainerRefContext';
import { useDownloadAssets } from 'context/DownloadAssetsContext';

const selectionColors = [
  {
    id: 1,
    label: 'color1',
    hex: '#929292',
    hsl: 'hsla(0, 0%, 57%, 1)',
  },
  {
    id: 2,
    label: 'color2',
    hex: '#B995E5',
    hsl: 'hsla(0, 0%, 57%, 1)',
  },
  {
    id: 3,
    label: 'color3',
    hex: '#E595DD',
    hsl: 'hsla(306, 61%, 74%, 1)',
  },
  {
    id: 4,
    label: 'color4',
    hex: '#E59596',
    hsl: 'hsla(359, 61%, 74%, 1)',
  },
  {
    id: 5,
    label: 'color5',
    hex: '#E5C095',
    hsl: 'hsla(32, 61%, 74%, 1)',
  },
  {
    id: 6,
    label: 'color6',
    hex: '#E5E295',
    hsl: 'hsla(58, 61%, 74%, 1)',
  },
  {
    id: 7,
    label: 'color7',
    hex: '#B8E595',
    hsl: 'hsla(94, 61%, 74%, 1)',
  },
  {
    id: 8,
    label: 'color8',
    hex: '#95E5AD',
    hsl: 'hsla(138, 61%, 74%, 1)',
  },
  {
    id: 9,
    label: 'color9',
    hex: '#95D4E5',
    hsl: 'hsla(193, 61%, 74%, 1)',
  },
  {
    id: 10,
    label: 'color10',
    hex: '#95A2E5',
    hsl: 'hsla(230, 61%, 74%, 1)',
  },
  {
    id: 11,
    label: 'color11',
    hex: '#993E17',
    hsl: 'hsla(18, 74%, 35%, 1)',
  },
  {
    id: 12,
    label: 'color12',
    hex: '#179926',
    hsl: 'hsla(127, 74%, 35%, 1)',
  },
  {
    id: 13,
    label: 'color13',
    hex: '#177299',
    hsl: 'hsla(198, 74%, 35%, 1)',
  },
  {
    id: 14,
    label: 'color14',
    hex: '#201799',
    hsl: 'hsla(244, 74%, 35%, 1)',
  },
  {
    id: 15,
    label: 'color15',
    hex: '#99175A',
    hsl: 'hsla(329, 74%, 35%, 1)',
  },
];
const Innerfolder = ({
  damfieldid,
  resethandleClick,
  isPoppedUp,
  HandleSave,
  showHeader = true,
  showFolders = true,
  showViewOptions = true,
  showImages = true,
  isUpload = true,
  stateData = [],
  assetsData = {
    folders: [],
    images: [],
  },
}) => {
  const { startDownload } = useDownloadAssets();
  const [state, setstate] = useState(stateData);
  const [modal, setModal] = useState(false);
  const [selectedDamFieldId, setSelectedDamFieldId] = useState(null);
  const [upload, setupload] = useState(false);
  const [textvalue, settextvalue] = useState();
  const [showbar, setshowbar] = useState(false);
  const [show, setshow] = useState(true);
  const [newfolder, setnewfolder] = useState();
  const [selectedView, setSelectedView] = useState('Masonry View');
  const [AddToCollectionModal, setAddToCollectionModal] = useState(false);
  const toggle = () => {
    setActiveId();
    setModal(true);
  };
  const [loadedData, setLoaded] = useState(0);
  const [totalData, setTotal] = useState(0);
  const [disableDropBox, setDisableDropBox] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [files, setFiles] = useState([]);
  const [previewFlag, setPreviewFlag] = useState(false);
  const [folderId, setFolderId] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [deletemodal, setdeletemodal] = useState(false);
  const [currentModalFolderName, setCurrentModalFolderName] = useState('');
  const [supportWebp, setSupportWebp] = useState(false);
  const [sharelink, setsharelink] = useState(false);
  const [expiredate, setexpiredate] = useState();
  const [expitetime, setexpitetime] = useState();
  const [indexdata, setindexdata] = useState();
  const [passname, setpassname] = useState('');
  const [searchData, setSearchData] = useState('');
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [innerFolderData, setInnerFolderData] = useState([]);
  const [activeId, setActiveId] = useState();

  const { insideFolderFolderData, insideFolderId, selectedAssets, selectedFolders } = useSelector(
    (state) => state.dam,
  );
  const { UploadFiles } = useDownloadAssets()
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const params = useParams();
  const location = useLocation();
  const [isExpiration, setIsExpiration] = useState(false);
  const [assetInfo, setAssetInfo] = useState({});
  const [emails, setEmails] = useState([]);
  const [Authenticated, setAuthenticated] = useState(false);
  const [responsedLink, setResponsedLink] = useState();
  const [error, setError] = useState({});
  const [movetoModal, setMovetoModal] = useState(false);
  const [prevIndexSelected, setPrevIndexSelected] = useState();
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [currentFolderDetails, setCurrentFolderDetails] = useState();
  const { containerRef: listInnerRef, setScrollHandler } = useContainerRef();
  const [isAvailableData, setisAvailableData] = useState(true);
  const [metaData, setMetaData] = useState({
    currentPage: 0,
    pageSize: 50,
  });
  const [openRightSection, setOpenRightSection] = useState(false);
  const [FolderLoading, setFolderLoading] = useState(false)
  const { getRootProps, isDragActive } = useDropzone({
    noClick: true,
    noKeyboard: true,
    multiple: true,
    onDrop: (acceptedFiles) => {
      uploadFiless(acceptedFiles, getLastSegment(location?.pathname));
      // if (onUpload) {
      //   onUpload(acceptedFiles, Data);
      // }
    },
  });

  const closeBtn = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => setModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );
  const closeBtn1 = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => setAddToCollectionModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const AddInArray = (data, isdirect = false) => {
    var arr = state;
    arr.push(data);
    setstate(isdirect ? [data] : arr);
  };

  const [assets, setAssets] = useState(assetsData);

  const datashow = async () => {
    if (!showHeader || !damfieldid) return;
    setIsLoading(true);
    setTimeout(async () => {
      // + `${folderId}?pageNo=${metaData?.currentPage}&rowSize=50`
      const data = await Axios.get(
        getSingleFolder + `${damfieldid}?pageNo=${metaData?.currentPage}&rowSize=50`,
      );

      // const folderIds = subfolderData?.folders?.[0]?.subfolders?.map((folder) => folder?.id);

      //   const folder_related_color = await Axios.get(`${GET_FOLDER_COLORS}?folderIds=${folderIds}`);
      dispatch(setInsideFolderId(damfieldid));
      setIsLoading(false);
      AddInArray(data.data.data, true);
      dispatch(setInsideFolderFolderData(data.data.data));
      setAssets(data.data.data);
    }, 200);
  };

  const handleEmailChange = (emails) => {
    setEmails(emails);
  };
  const [images, setImages] = useState();
  const Imagedata = assets?.images?.map((value) => {
    return { src: value.fileThumbnail, width: value.fileWidth, height: value.fileHeight };
  });

  useEffect(() => {
    setImages(Imagedata);
  }, [assets]);

  const fetchSubfolders = async (id) => {
    if (!showHeader) return;

    if (!isAvailableData && metaData?.currentPage > 0) {
      return;
    }
    try {
      const response = await Axios.get(
        getSingleFolder + `${id}?pageNo=${metaData?.currentPage}&rowSize=50`,
      );
      const { folders, images, paginationDto } = response.data.data;

      setisAvailableData(metaData?.currentPage * 50 < paginationDto?.totalAmountOfElements);
      const subfoldersData = {
        folders: folders || [],
        images: images || [],
      };
      return subfoldersData;
    } catch (error) {
      console.error('Error fetching subfolders:', error);
      return { folders: [], images: [] };
    }
  };

  const handleClick = async (id) => {
    setSearchData('');

    const navigatevalue = location.pathname;
    const newPath = `${navigatevalue}/${id}`;
    navigate(newPath);

    dispatch(setInsideFolderId(id));
  };

  const handlenavigate = (index) => {
    setSearchData('');

    const splittedData = innerFolderData.slice(0, index + 1);
    const navigatedata = '/dam/v2/assets';
    // join all ids into a single path
    const fullPath = navigatedata + '/' + splittedData.map((item) => item.id).join('/');
    navigate(fullPath);
    // setAssets(state[index]);
    // setstate([...state.slice(0, index + 1)]);
  };

  const folderedit = async () => {
    try {
      const formData = new FormData();
      formData.append('folderId', selectedDamFieldId);
      formData.append('newFolderName', textvalue);
      const response = await Axios.post(Editfolder, formData);

      if (response.data.success) {
        datashow();
        getData();
        setAddToCollectionModal(false);
        toast.success(response?.data?.message ?? 'Folder Renamed Successfully');
      } else {
        // Handle error case
        setAddToCollectionModal(false);
        toast.error('Folder Rename Failed');
      }
    } catch (error) {
      // Handle error
    }
    setAddToCollectionModal(false);
    setshowbar(false);
  };

  const handledelette = async () => {
    try {
      setDeleteLoading(true);
      setTimeout(() => {
        setdeletemodal(false);
      }, 4000);
      const data = await Axios.post(DELETE_MULTIPLE_ASSET, {
        fileId: [],
        folderId: [selectedDamFieldId],
      });
      getData();
      setDeleteLoading(false);
      setdeletemodal(false);
      toast.success(data?.data?.message ?? 'Folder Deleted Successfully');
    } catch (err) {
      setDeleteLoading(false);
      setdeletemodal(false);
      console.error(err);
    }
  };

  const folderaddded = async () => {
    try {
      const formData = new FormData();
      formData.append('folderName', textvalue);
      formData.append('parentFolderId', newfolder || damfieldid);
      const response = await Axios.post(Addfolder, formData);
      if (response.data.success) {
        // Folder created successfully, fetch updated folder data
        datashow();
        getData();
        setModal(false);
        toast.success(response?.data?.message ?? 'Folder created successfully');
      } else {
        // Handle error case
        toast.error('Folder created  Failed');
      }
    } catch (error) {
      // Handle error
      toast.error(error.response.data.message);

    }
    // Close the modal
  };

  const handleChange = (evt) => {
    const { value } = evt.target;
    settextvalue(value);
  };
  const toggleAddToCollection = () => {
    setAddToCollectionModal(!AddToCollectionModal);
  };

  const handleshow = (id) => {
    setshowbar(id === showbar ? null : id);
    setSelectedDamFieldId(id);
  };

  const handleViewChange = (view) => {
    setSelectedView(view);
  };

  const toggleupload = () => {
    setupload(true);
  };

  const closeBtn4 = (
    <img
      src={close}
      className="close"
      onClick={() => setupload(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const options = {
    onUploadProgress: (progressEvent) => {
      const { loaded, total } = progressEvent;
      let percent = Math.floor((loaded * 100) / total);

      if (percent < 100) {
        setLoaded(loaded);
        setTotal(total);
        setUploadPercentage(percent);
      } else {
        setUploadPercentage('');
      }
    },
  };

  const stompConnect = () => {
    const socket = new WebSocket(`${DAM_SOCKET_URL}/ws`);

    const client = over(socket);
    client.connect(
      {},
      (frame) => {
        client.subscribe(`/topic/receiveMessage/${user.userID}`, (payload) => {
          if (payload?.body?.includes('is uploading')) {
            setDisableDropBox(true);
          } else if (payload?.body?.includes('uploaded successfully')) {
            setDisableDropBox(false);
            setFiles();
            setUploadPercentage(100);
            HandleSave && HandleSave();
            setupload(false);
            setDisableDropBox(false);
            datashow();
            setUploadPercentage(0);
            toast.success(payload?.body);
            client.subscribe(`/topic/disconnect/${user.userID}`, (payload) => {
              if (payload.body === 'disconnected' || payload.body === 'Disconnected') {
                // toast.success('successfully Disconnected');
                // getPdfList();
              }
            });
          } else if (payload?.body?.includes('')) {
          } else if (payload.body === 'Text Parsing Done') {
            // getPdfList();
            client.subscribe(`/topic/disconnect/${user.userID}`, (payload) => {
              if (payload.body === 'disconnected' || payload.body === 'Disconnected') {
                // toast.success('successfully Disconnected');
                // getPdfList();
              }
            });
          } else if (payload.body === 'disconnected' || payload.body === 'Disconnected') {
            // getPdfList();
            // toast.success('successfully Replaced');
            // toast.info('Please change the cover image if you want ');
          }
        });
      },
      stompFailureCallback,
    );
  };

  const stompFailureCallback = (error) => {
    console.error('STOMP connection error:', error);
    toast.error('Failed to connect to the server. Please try again.');
  };

  const uploadFiles = async () => {
    setDisableDropBox(true);
    let data = new FormData();
    for (let i = 0; i < files.length; i++) {
      data.append('files', files[i]?.videoThumb ? files[i]?.file : files[i]);
    }
    for (let i = 0; i < files.length; i++) {
      data.append('videoThumbnail', files[i]?.videoThumb ? files[i]?.videoThumb?.[0] : null);
    }

    data.append('folderId', folderId ?? damfieldid);

    try {
      stompConnect();
      const res = await UploadFiles(data);
    } catch (error) {
      console.error('Error uploading files:', error);
      // toast.error('Failed to upload files. Please try again.');
    } finally {
      // setDisableDropBox(false);
      datashow();
    }
    datashow();
    // setupload(false);
    setUploadPercentage(0);
  };

  const FolderselectAsset = (index) => {
    let newAssets = insideFolderFolderData?.images;
    newAssets[index].selected = !newAssets[index]?.selected;
    // setAssets([...newAssets]);
    setAssets({
      ...assets,
      images: newAssets,
    });
  };

  const handleshowdata = async (damFileId, index) => {
    setResponsedLink();
    setError({});
    setexpiredate();
    setexpitetime();
    setAssetInfo({});
    setEmails([]);
    setAuthenticated(true);
    setIsExpiration(false);
    setindexdata(index);
    setsharelink(!sharelink);
    setshowbar(false);
    setActiveId();
  };

  const Shareshowdata = (e) => {
    setActiveId();
    e.stopPropagation();
    toggleShareLink();
  };
  const toggleShareLink = () => {
    setsharelink(!sharelink);
  };

  const deletmodal = (folderName) => {
    setdeletemodal(true);
    setpassname(folderName);
  };

  const getData = async (isload = true) => {
    try {
      setIsLoading(isload);
      // const response = await Axios.post(
      //   `${GET_INSIDE_FOLDER_DATA}?assetId=${damfieldid}&searchKeyword=${searchData}&forWhich=folder`,
      // );
      const folderId = getLastSegment(location?.pathname);
      let response;
      if (!searchData) {
        response = await Axios.get(
          getSingleFolder + `${folderId}?pageNo=${metaData?.currentPage}&rowSize=50`,
        );
      } else {
        if (searchData?.length > 0 && searchData?.length < 3) {
          setIsLoading(false);
          return;
        }
        response = await Axios.post(GET_INSIDE_FOLDER_DATA, {
          searchKeyword: searchData,
          ...(folderId && {
            parentFolderId: folderId,
          }),
        });
      }

      // console.log(response?.data?.data?.folders?.[0]?.subfolders, 'response line no 601');

      const folderIds = response?.data?.data?.folders?.[0]?.subfolders?.map((folder) => folder?.id);

      const folder_related_color = await Axios.get(`${GET_FOLDER_COLORS}?folderIds=${folderIds}`);
      // const _combine_data =
      //   metaData?.currentPage > 0 || metaData?.isScrolling
      //     ? [...selectedAssets, ...subfolderData?.images]
      //     : subfolderData?.images;

      dispatch(
        SelectedAssetData(!searchData ? response?.data?.data?.images : response?.data?.data?.files),
      );
      setIsLoading(false);

      dispatch(
        setInsideFolderFolderData({
          folders: [
            {
              id: insideFolderFolderData?.folders?.[0]?.id,
              folderName: insideFolderFolderData?.folders?.[0]?.folderName,
              subfolders: !searchData
                ? response?.data?.data?.folders?.[0]?.subfolders
                : response?.data?.data?.folders ?? [],
            },
          ],
          images: !searchData ? response?.data?.data?.images : response?.data?.data?.files ?? [],
        }),
      );

      dispatch(
        SetSelctedFoldersData(
          !searchData
            ? response?.data?.data?.folders?.[0]?.subfolders?.map((item) => ({
              ...item,
              isSelected: false,
              color: folder_related_color?.data?.data?.find((d) => d.folderId === item.id)?.color,
            }))
            : response?.data?.data?.folders?.map((item) => ({
              ...item,
              isSelected: false,
              color: folder_related_color?.data?.data?.find((d) => d.folderId === item.id)?.color,
            })) ?? [],
        ),
      );

      setAssets((prev) => ({
        ...prev,
        folders: [{ id: damfieldid, subfolders: response?.data?.data ?? [] }],
      }));
    } catch (err) {
      setIsLoading(false);

      console.error(err);
    }
  };

  const handleSaveColor = async (Data, selectedColor) => {
    try {
      const result = await Axios.put(UPDATE_FOLDER_COLOR, {
        color: selectedColor?.hex,
        folderId: Data?.id,
      });
      toast.success(result?.data?.message);
      setActiveId(null);
      // HandleDelete();
      setOpenRightSection(false);
      getData(false);
      // setSelectedColor();
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (!showHeader) return;
    if (isFirstLoad) {
      dispatch(SelectedAssetData([]));
      dispatch(SetSelctedFoldersData([]));
      setIsFirstLoad(false);
      return;
    }
    const delaysearcfun = setTimeout(async () => {
      getData();
    }, 500);
    return () => clearTimeout(delaysearcfun);
  }, [searchData]);

  useEffect(() => {
    if (isPoppedUp && assets?.folders?.[0]?.id) {
      setFolderId(assets?.folders?.[0]?.id); // Set the  folderId
      setCurrentModalFolderName(assets?.folders[0]?.folderName);
    }
  }, [isPoppedUp, assets]);

  const getLastSegment = (path) => {
    const parts = path.split('/').filter(Boolean); // split and remove empty values
    return parts[parts.length - 1]; // return last value
  };

  const handledownload = async (data) => {
    try {
      // console.log(data, 'data');
      // const _url = `${DOWNLOAD_SELECTED_FOLDER}?folderId=${data?.id}`;
      var _data = {
        fileId: [],
        folderId: [data?.id],
      }
      await startDownload(_data)
      setActiveId();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const folderId = getLastSegment(location?.pathname);
    try {
      (async () => {
        setIsLoading(true)
        const multiarray_pathname = location?.pathname.split('assets/')[1];
        const response_data = await Axios.get(
          `${ROUTED_INNNER_FOLDER_DATA}?folderIds=${multiarray_pathname?.split('/')}`,
        );
        const multiarray_id_index = multiarray_pathname?.split('/');
        const ordered_folder_data = multiarray_id_index.map((id) =>
          response_data?.data?.data.find((item) => item.id === id),
        );
        setCurrentFolderDetails(ordered_folder_data?.[ordered_folder_data?.length - 1]);
        setInnerFolderData(ordered_folder_data);
        const subfolderData = await fetchSubfolders(folderId);

        const folderIds = subfolderData?.folders?.[0]?.subfolders?.map((folder) => folder?.id);

        const folder_related_color = await Axios.get(`${GET_FOLDER_COLORS}?folderIds=${folderIds}`);

        setnewfolder(folderId);

        if (metaData?.currentPage <= 0) {
          dispatch(
            SetSelctedFoldersData(
              subfolderData?.folders?.[0]?.subfolders?.map((item) => ({
                ...item,
                isSelected: false,
                color: folder_related_color?.data?.data?.find((d) => d.folderId === item.id)?.color,
              })),
            ),
          );
        }

        dispatch(setInsideFolderFolderData(subfolderData));
        setAssets(subfolderData);
        AddInArray(subfolderData);
        setImages(subfolderData?.images);
        const _combine_data =
          metaData?.currentPage > 0 || metaData?.isScrolling
            ? [...selectedAssets, ...(subfolderData?.images? subfolderData?.images : [])]
            : subfolderData?.images;

        dispatch(SelectedAssetData(_combine_data));
        setIsLoading(false)
        // dispatch(se)
      })();
    } catch (err) {
      console.error(err);
    }
  }, [location?.pathname, metaData?.currentPage]);

  const onScroll = () => {
    if (listInnerRef.current) {
      // if (isLoading) return;

      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;

      if (scrollTop + clientHeight >= scrollHeight - 200) {
        if (!isAvailableData) {
          return;
        }

        isAvailableData &&
          setMetaData((prev) => ({
            ...prev,
            currentPage: metaData?.currentPage + 1,
            isScrolling: true,
          }));
      }
    }
  };

  useEffect(() => {
    setScrollHandler(() => onScroll);
  }, []);

  const title = passname;
  const toggledelete = () => setdeletemodal(!deletemodal);

  return (
    <>
      {deletemodal && (
        <Deletemodel
          deletemodal={deletemodal}
          toggledelete={toggledelete}
          handleDelete={handledelette}
          Header={title}
          loading={deleteLoading}
        />
      )}

      {movetoModal && (
        <MoveToAssetDesign
          OpenModal={movetoModal}
          ToggleModal={() => {
            setMovetoModal(!movetoModal);
          }}
          Data={selectedDamFieldId}
          HandleAssetMove={() => {
            getData();
          }}
        />
      )}
      <Modal isOpen={upload} toggle={toggleupload} size="xl" style={{ width: '50%' }}>
        <ModalHeader toggle={toggleupload} close={closeBtn4}>
          {currentModalFolderName}
        </ModalHeader>
        <ModalBody className="">
          <Uploadfile
            loadedData={loadedData}
            totalData={totalData}
            disableDropBox={disableDropBox}
            uploadPercentage={uploadPercentage}
            uploadFiles={uploadFiles}
            files={files}
            setFiles={setFiles}
            previewFlag={previewFlag}
            setPreviewFlag={setPreviewFlag}
          />
        </ModalBody>
      </Modal>

      <Modal isOpen={modal} toggle={toggle} style={{ width: '50%' }}>
        <ModalHeader toggle={toggle} close={closeBtn}>
          Create Folder
        </ModalHeader>
        <ModalBody>
          <InputC
            type="text"
            label="Folder Name"
            name="textvalue"
            placeholder="Enter name of folder"
            change={(e) => handleChange(e)}
          />
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}>
          <ButtonC text="Close" click={() => setModal(false)} size="lg" color="Secondary" />

          <ButtonC text="Save" click={folderaddded} size="lg" />
        </ModalFooter>
      </Modal>

      <Modal isOpen={AddToCollectionModal} toggle={toggleAddToCollection} style={{ width: '50%' }}>
        <ModalHeader toggle={toggleAddToCollection} close={closeBtn1}>
          Rename Folder
        </ModalHeader>
        <ModalBody>
          <InputC
            type="text"
            label=""
            name="textvalue"
            placeholder="Enter name of folder"
            inputvalue={textvalue}
            change={(e) => handleChange(e)}
          />
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}>
          <ButtonC
            text="Close"
            click={() => setAddToCollectionModal(false)}
            size="lg"
            color="Secondary"
          />
          <ButtonC text="Save" click={folderedit} size="lg" />
        </ModalFooter>
      </Modal>

      {sharelink && (
        <ShareAssetSection
          openModal={sharelink}
          ParentId={[selectedDamFieldId]}
          toggleOpenModal={() => {
            setsharelink(!sharelink);
          }}
          shareType={0}
        />
      )}

      {showHeader && (
        <div className={`mt-2 div-width-print  ${isPoppedUp && 'flex justify-content-between text-center div-width-print'}`}>
          <div className={!isPoppedUp && 'textinner'}>
            {' '}
            <span
              className="pointer"
              onClick={() => {
                navigate('/dam/v2/assets');
              }}
            >
              Assets{' '}
            </span>
            {innerFolderData.map((item, index) => (
              <span className="pointer" onClick={() => handlenavigate(index)} key={index}>
                {/* <WordWrapEllipse Text={`/ ${item?.folderName}`} /> */}/{' '}
                {' ' + item?.folderName + ' '}
              </span>
            ))}
          </div>

          {isPoppedUp && <ButtonC size="lg" text="New Folder" click={toggle} />}
        </div>
      )}

      <div
        className={`d-flex no-print justify-content-${!isPoppedUp ? 'between' : 'end'} ${isPoppedUp ? 'mt-2' : 'mt-5'}`}
      >
        {!isPoppedUp && (
          <InputC
            type="Searchbar"
            placeholder="Search...."
            size="lg"
            name=""
            inputvalue={searchData}
            change={(e) => {
              setSearchData(e.target.value);
            }}
          />
        )}
        {!isPoppedUp && (
          <div className="d-flex align-items-center gap-2">
            {showViewOptions && (
              <div style={{ position: 'relative' }}>
                <h4
                  style={{
                    position: 'absolute',
                    bottom: '34px',
                    fontFamily: 'Inter',
                    fontWeight: '500',
                    fontSize: '14px',
                  }}
                >
                  View
                </h4>
                <Viewbutton size="md" onSelectView={handleViewChange} />
              </div>
            )}

            {/* <ButtonC size="lg" text="New Folder" click={toggle} /> */}

            <div className="d-flex gap-2">
              {selectedAssets?.filter((item) => item?.isSelected)?.length > 0 ||
                selectedFolders?.filter((item) => item?.isSelected)?.length > 0 ? (
                <SelectionActions
                  handleDelete={() => {
                    // dispatch(setselectedas)
                    getData();
                    // getAllFolders();
                  }}
                  HandleAssetMove={() => {
                    getData();
                    // getAllFolders();
                  }}
                />
              ) : (
                <div
                  className="d-flex justify-content-end relative"
                  style={{
                    position: 'relative',
                  }}
                >
                  <CommonSidePortal
                    activeId={activeId}
                    setActiveId={setActiveId}
                    portalId={-1}
                    ViewSection={
                      <ButtonC size="lg" click={() => { }}>
                        <span className="d-flex gap-2 justify-content-center items-center text-center align-items-center">
                          {DAM_SVG?.additionIconSvg} Add
                        </span>
                      </ButtonC>
                    }
                    OpenSection={
                      <div className="openAdditionDialog">
                        <div
                          onClick={() => {
                            dispatch(
                              setInnerFolderDetails(innerFolderData?.[innerFolderData?.length - 1]),
                            );
                            dispatch(setInsideFolderFolderData(getLastSegment(location?.pathname)));
                            navigate('/dam/v2/uploads');
                          }}
                        >
                          {DAM_SVG.uploadSvgIcon} Asset Upload
                        </div>
                        <div onClick={toggle}>{DAM_SVG.addiitonSvgIcon} New Folder</div>
                      </div>
                    }
                  />

                  {/* {openAdditionDialog && (
                <div className="openAdditionDialog">
                  <div
                    onClick={() => {
                      dispatch(setInsideFolderFolderData(getLastSegment(location?.pathname)));
                      navigate('/dam/v2/uploads');
                    }}
                  >
                    {DAM_SVG.uploadSvgIcon} Asset Upload
                  </div>
                  <div onClick={toggle}>{DAM_SVG.addiitonSvgIcon} New Folder</div>
                </div>
              )} */}
                </div>
              )}
            </div>

            {/* <ButtonC size="lg" text="Upload" click={() => handleFolderClick(assets.folders[0].id)} /> */}

            {/* <ButtonC
              size="lg"
              text="Upload"
              click={() => handleFolderClick(assets.folders[0].id, assets.folders[0].folderName)}
            /> */}
          </div>
        )}
      </div>
      {isPoppedUp && isUpload && (
        <div className="mt-2">
          {' '}
          <Uploadfile
            loadedData={loadedData}
            totalData={totalData}
            disableDropBox={disableDropBox}
            uploadPercentage={uploadPercentage}
            uploadFiles={uploadFiles}
            files={files}
            setFiles={setFiles}
            previewFlag={previewFlag}
            setPreviewFlag={setPreviewFlag}
            isDropCircle={true}
          />
        </div>
      )}

      {isLoading ? (
        <SpinnerLoader />
      ) : (
        <div className="mt-3">
          {showFolders && selectedFolders?.length !== 0 && (
            <div>
              <div
                className="dis_grid grid_cols_5 "
                style={{
                  gap: '1rem',
                }}
              >
                {selectedFolders?.map((value, index) => (
                  <div lg={3} key={value.id}>
                    <FolderGridSecondVersion
                      Data={value}
                      Index={index}
                      Title={<WordWrapEllipse Text={value?.folderName} MaxWidth={'15ch'} />}
                      isFolder={true}
                      isSelected={
                        selectedFolders?.find((item, index) => item?.id === value?.id)?.isSelected
                      }
                      HandleSelect={(data) => {
                        if (data?.Key === 4) {
                          handleClick(value?.id);
                          return;
                        }
                        if (data?.Key === 1) {
                          setPrevIndexSelected(value?.id);
                          const updatedValue = selectedFolders?.map((item) =>
                            item?.id === value?.id
                              ? { ...item, isSelected: !item?.isSelected }
                              : { ...item, isSelected: false },
                          );
                          dispatch(SetSelctedFoldersData(updatedValue));
                        } else if (data?.Key === 2) {
                          setPrevIndexSelected(value?.id);

                          const updatedValue = selectedFolders?.map((item) =>
                            item?.id === value?.id
                              ? { ...item, isSelected: !item?.isSelected }
                              : { ...item },
                          );

                          dispatch(SetSelctedFoldersData(updatedValue));
                        } else if (data?.Key === 3) {
                          const returnedValueData = selectRangeByUUID(
                            selectedFolders,
                            prevIndexSelected,
                            value?.id,
                            'id',
                          );
                          dispatch(SetSelctedFoldersData(returnedValueData));
                        }
                      }}
                      EllipseActions={
                        <CommonSidePortal
                          activeId={activeId}
                          setActiveId={setActiveId}
                          portalId={index}
                          ViewSection={<CommonThreeDotSvg />}
                          OpenSection={
                            <div className="">
                              <div
                                className="d-flex align-items-center gap-2 pointer"
                                onClick={() => {
                                  setMovetoModal(true);
                                  setSelectedDamFieldId(value.id);
                                  setActiveId();
                                }}
                              >
                                {DAM_SVG.moveAssetSvgIcon}
                                <p className="list_cart">Move Folder</p>
                              </div>
                              <div
                                className="d-flex align-items-center gap-2 pointer"
                                onClick={(e) => {
                                  setSelectedDamFieldId(value?.id);
                                  e.stopPropagation();
                                  setActiveId();
                                  deletmodal(value.folderName);
                                }}
                              >
                                {' '}
                                <img src={deleteicon} alt="deleteicon" />{' '}
                                <p className="list_cart">Delete</p>
                              </div>
                              <div
                                className="d-flex align-items-center gap-2 pointer"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setActiveId();

                                  handledownload(value);
                                }}
                              >
                                {' '}
                                <img src={download} alt="downloadicon" />{' '}
                                <p className="list_cart">Download</p>
                              </div>
                              <div
                                className="p-relative"
                                style={{
                                  position: 'relative',
                                }}
                              >
                                <div
                                  className="d-flex justify-content-between align-items-center gap-2 pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setOpenRightSection(!openRightSection);
                                  }}
                                >
                                  <div className="d-flex gap-2 align-items-center">
                                    {DAM_SVG.labelByColorSvgIcon}
                                    <p className="list_cart">Label By Color</p>
                                  </div>
                                  <div
                                    style={{
                                      paddingRight: '16px',
                                    }}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      // setOpenRightSection(!openRightSection);
                                    }}
                                  >
                                    {DAM_SVG.rightSideSvgIcon}
                                  </div>
                                  {/* <img src={renameicon} alt="renameicon" /> */}
                                </div>
                                {openRightSection && (
                                  <div
                                    className="p-absolute cart_list"
                                    style={{
                                      position: 'absolute',
                                      left: '100%',
                                      padding: '16px',
                                    }}
                                  >
                                    <div className="color_heading">Folder Color</div>

                                    <div className="dis_grid grid_cols_5 gap-2">
                                      {selectionColors?.map((item) => (
                                        <div
                                          style={{
                                            backgroundColor: item?.hex,
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                          }}
                                          onClick={() => {
                                            handleSaveColor(value, item);
                                          }}
                                        >
                                          {' '}
                                          {value?.color === item?.hex &&
                                            DAM_SVG.folderSelectTickIcon}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div
                                className="d-flex align-items-center gap-2 pointer"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setActiveId();
                                  settextvalue(value.folderName);
                                  setSelectedDamFieldId(value?.id);
                                  setAddToCollectionModal(!AddToCollectionModal);
                                }}
                              >
                                <img src={renameicon} alt="renameicon" />
                                <p className="list_cart">Rename</p>
                              </div>
                              <div
                                className="d-flex align-items-center gap-2 pointer"
                                onClick={(e) => {
                                  setActiveId();
                                  e.stopPropagation();
                                  setSelectedDamFieldId(value?.id);
                                  setActiveId();
                                  dispatch(setOpenPopup(value));
                                }}
                              >
                                {' '}
                                <img src={shareicon} alt="componenticon" />{' '}
                                <p className="list_cart">Share</p>
                              </div>
                              <div
                                className="d-flex align-items-center gap-2 pointer"
                                onClick={(e) => {
                                  setActiveId();
                                  setSelectedDamFieldId(value?.id);
                                  Shareshowdata(e);
                                  handleshowdata(value?.id, 0);
                                }}
                              >
                                {' '}
                                {DAM_SVG.permissionSvg}
                                <p className="list_cart">Invite Outside Org.</p>
                              </div>
                            </div>
                          }
                          Top={'15px'}
                          Right={'170px'}
                        />
                      }
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {showImages && (
            <div>
              <div
                className="mt-3"
                {...getRootProps()}
                style={{
                  position: 'relative',
                  minHeight: '60vh',
                }}
              >
                {isDragActive && (
                  <div
                    style={{
                      position: 'absolute',
                      zIndex: 99999,
                      height: '100%',
                      width: '100%',
                      backgroundColor: '#21cfd670',
                    }}
                  ></div>
                )}
                <div>
                  <div className="pt-1 pb-1">
                    {selectedView === 'Masonry View' && (
                      <Assitdata
                        assets={insideFolderFolderData?.images?.map((item) => ({
                          ...item,
                          folderId: assets?.folders?.[0]?.id ?? insideFolderId ?? '',
                        }))}
                        datashow={getData}
                        show={show}
                        setAssets={setAssets}
                        collectionID=""
                        supportWebp={supportWebp}
                        showData={false}
                        showCopyLing={false}
                        showRenderActionButton={false}
                      />
                    )}
                    {selectedView === 'Grid View' && (
                      <Griddata
                        assets={insideFolderFolderData?.images}
                        datashow={datashow}
                        show={show}
                        setAssets={setAssets}
                        FolderselectAsset={FolderselectAsset}
                        supportWebp={supportWebp}
                      />
                    )}
                    {selectedView === 'List View' && (
                      <Tabledata
                        assets={insideFolderFolderData?.images}
                        setAssets={setAssets}
                        FolderselectAsset={FolderselectAsset}
                        supportWebp={supportWebp}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {insideFolderFolderData?.folders?.[0]?.subfolders?.length === 0 &&
            selectedAssets?.length === 0 && (
              <div className=" d-flex align-item-center justify-content-center">
                <div className="w-50">
                  <Nodatacomponent />
                </div>
              </div>
            )}
        </div>
      )}
    </>
  );
};

export default Innerfolder;
